import { HealthCheckComponent } from './health-check/health-check.component';
import { RenewPasswordComponent } from './renew-password/renew-password.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ContentLayoutComponent } from './../shared/components/layout/content-layout/content-layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClientsComponent } from './clients/clients.component';
import { OrdersComponent } from './orders/orders.component';
import { AccountComponent } from './account/account.component';
import { UsersComponent } from './users/users.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { UserProviderComponent } from './user-provider/user-provider.component';
import { UserShopComponent } from './user-shop/user-shop.component';
import { FicheClientComponent } from './fiche-client/fiche-client.component';
import { FicheChantierComponent } from './fiche-chantier/fiche-chantier.component';


const routes: Routes = [
    {
        path:
            'connexion',
        component: LoginComponent,
        data: {
            title: 'Connexion',
            breadcrumb: 'Connexion'
        }
    },
    {
        path:
            'mot-de-passe-oublie',
        component: ForgetPasswordComponent,
        data: {
            title: 'Mot de passe oublié',
            breadcrumb: 'Mot de passe oublié'
        }
    },
    {
        path:
            'reinitialiser-le-mot-de-passe/:token',
        component: RenewPasswordComponent,
        data: {
            title: 'Réinitialiser le mot de passe',
            breadcrumb: 'Réinitialiser le mot de passe'
        }
    },
    {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'clients',
                component: ClientsComponent,
                data: {
                    title: 'Clients',
                    breadcrumb: 'Clients'
                }
            },
            {
                path: 'commandes',
                component: OrdersComponent,
                data: {
                    title: 'Commandes',
                    breadcrumb: 'Commandes'
                }
            },
            {
                path: 'mon-compte',
                component: AccountComponent,
                data: {
                    title: 'Mon Compte',
                    breadcrumb: 'Mon Compte'
                }
            },
            {
                path: 'utilisateurs',
                component: UsersComponent,
                data: {
                    title: 'Utilisateurs',
                    breadcrumb: 'Utilisateurs'
                }
            },
            {
                path: 'fournisseurs',
                component: UserProviderComponent,
                data: {
                    title: 'Fournisseurs',
                    breadcrumb: 'Fournisseurs'
                }
            },
            {
                path: 'adherents',
                component: UserShopComponent,
                data: {
                    title: 'Adhérents',
                    breadcrumb: 'Adhérents'
                }
            },
            {
                path: 'fiche-client',
                component: FicheClientComponent,
                data: {
                    title: 'Fiches clients',
                    breadcrumb: 'Fiches clients'
                }
            },
            {
                path: 'fiche-chantier',
                component: FicheChantierComponent,
                data: {
                    title: 'Fiches chantiers',
                    breadcrumb: 'Fiches chantiers'
                }
            },
            {
                path: 'etat-systeme',
                component: HealthCheckComponent,
                data: {
                    title: 'Etat Système',
                    breadcrumb: 'Etat Système'
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BoRoutingModule { }
